import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmChevronRightCircle } from '@websolutespa/bom-mixer-icons';
import { ThronPlayer } from '../../components/ThronPlayer/thron-player.js';
import { VideoPlayer } from '../../components/VideoPlayer/video-player.js';

const CardWrapper = _a => {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  // const label = useLabel();
  const classNames = getClassNames('llm__card', `llm__card--${props.cardType}`);
  return jsx("div", {
    className: classNames,
    children: children
  });
};
const Card = props => {
  const {
    item
  } = props;
  const label = useLabel();
  return jsxs(CardWrapper, Object.assign({}, item, {
    children: [item.media.type === 'image' && item.cta.url && jsx("a", {
      className: "llm__card-media",
      href: item.cta.url,
      target: "_blank",
      rel: "noreferrer",
      "aria-label": item.cta.label || label('llm.tellMeMore'),
      children: jsx("div", {
        className: "llm__card-asset",
        children: jsx("img", {
          src: item.media.src,
          alt: ""
        })
      })
    }), item.media.type === 'image' && !item.cta.url && jsx("div", {
      className: "llm__card-media",
      children: jsx("div", {
        className: "llm__card-asset",
        children: jsx("img", {
          src: item.media.src,
          alt: ""
        })
      })
    }), item.media.type === 'video' && jsx("div", {
      className: "llm__card-media",
      children: jsx("div", {
        className: "llm__card-asset",
        children: jsx(VideoPlayer, Object.assign({}, item))
      })
    }), item.media.type === 'thron' && jsx("div", {
      className: "llm__card-media",
      children: jsx("div", {
        className: "llm__card-asset",
        children: jsx(ThronPlayer, Object.assign({}, item))
      })
    }), jsxs("div", {
      className: "llm__card-content",
      children: [item.date && jsx("div", {
        className: "llm__card-date",
        children: item.date
      }), item.title && jsx("div", {
        className: "llm__card-title",
        dangerouslySetInnerHTML: {
          __html: item.title
        }
      }), item.abstract && jsx("div", {
        className: "llm__card-abstract",
        dangerouslySetInnerHTML: {
          __html: item.abstract
        }
      }), item.cta && item.cta.url && jsxs("a", {
        className: "llm__card-cta",
        href: item.cta.url,
        target: "_blank",
        rel: "noreferrer",
        children: [jsx("span", {
          children: item.cta.label || label('llm.tellMeMore')
        }), " ", jsx(IconLlmChevronRightCircle, {})]
      })]
    })]
  }));
};

export { Card, CardWrapper };
//# sourceMappingURL=card.js.map
